import { useEffect, useState } from 'react';
import { firestore, timeStamp, userPhone, userName } from './Firebase';
import { Link } from 'react-router-dom';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import {BsPlusSquare} from 'react-icons/bs'

const Roomcontainer = (props) => {
	const style = {
		color: '#303030',
		padding: '10px 15px',
		textDecoration:'none',
	};

	return (
		<div className="room-container flex-btw">
			<Link to="Playroom" className="room-name" style={style}>
				<span
					onClick={(e) => {
						localStorage.setItem('room-id', props.id);
					}}
				>
					{props.name}
				</span>
			</Link>
			<span>{props.owner}</span>
		</div>
	);
};

const CreateNewRoom = (props) => {
	const [roomName, setRoomName] = useState('');
	const [roomPassWord, setRoomPassWord] = useState('');

	function createRoom() {
		const roomId = Math.floor(Math.random() * 1000000 + Math.random() * 100000 * Math.random() * 9901);
		const ref = firestore.doc(`playHouse/${roomId}`);

		ref.set({
			owner: userName,
			ownerPhone: userPhone,
			name: roomName,
			createdAt: timeStamp(),
			audio: '',
			members: [userPhone],
			passWord: roomPassWord,
			nersonPlaying:'',
			nameOfPlayingAudio:'',
		});
		alert('Nice your Play room is ready. Invite others and enjoy');
	}

	return (
		<div className="add-play-room flex-col-evenly">
			<input
				placeholder="enter name "
				onChange={(e) => {
					setRoomName(e.target.value);
				}}
			/>
			<input
				placeholder="PassWord "
				onChange={(e) => {
					setRoomPassWord(e.target.value);
				}}
			/>
			<button onClick={(e) => createRoom()}>create</button>
			<span onClick={(e) => props.onState()}>close</span>
		</div>
	);
};

const Playhouse = () => {
	const [showCreateRoom, setShowCreateRoom] = useState(false);
	const [rooms, setRooms] = useState([]);
	//get the rooms
	const availableRoomsRef = firestore.collection(`playHouse`).orderBy('createdAt');
	const [availableRooms] = useCollectionData(availableRoomsRef, { idField: 'id' });

	useEffect(
		(e) => {
			if (availableRooms) {
				setRooms(availableRooms);
			}
		},
		[availableRooms]
	);

	return (
		<div className="page play-house ">
		<div className='top flex-btw'>
			<h2 className='tittle'>Play <span>|-|ouse</span></h2>
			<span className="add-play-room-btn" onClick={(e) => setShowCreateRoom(!showCreateRoom)}><BsPlusSquare/></span>
		</div>

			<div className="center flex-col-start">
				{rooms.map((a) => {
					return <Roomcontainer key={a.name} owner={a.owner} name={a.name} id={a.id} />;
				})}
			</div>

			

			{showCreateRoom && <CreateNewRoom onState={(e) => setShowCreateRoom(!showCreateRoom)} />}
		</div>
	);
};

export default Playhouse;
